<template>
  <tabs>
    <tab title="Products">
      <div class="m-3" style="height: 400px">
        <OrderProductTable
          v-if="order.details"
          :details="order.details"
        />
      </div>
    </tab>

    <tab title="Tracking">
      <div class="m-3" style="height: 400px">
        <OrderTrackingTable />
      </div>
    </tab>
    <tab title="Discounts">
      <div class="m-3" style="height: 400px">
        <OrderDiscountsTable/>
      </div>
    </tab>
  </tabs>
</template>

<script>
import Tab from "@/components/elements/Tab.vue";
import Tabs from "@/components/elements/Tabs.vue";
import OrderProductTable from "./OrderProductTable.vue";
import OrderTrackingTable from "./OrderTrackingTable.vue";
import OrderDiscountsTable from "./OrderDiscountsTable.vue";

export default {
  name: "OrderDetails",
  components: {
    OrderDiscountsTable,
    Tab,
    Tabs,
    OrderProductTable,
    OrderTrackingTable
  },
  props: {
    order: {
      type: Object,
      required: true
    },
  },
  data() {
    return {};
  },
  async created() {}
};
</script>
